import * as yup from 'yup'

export const envSchema = yup
  .object()
  .shape({
    VITE_APP_GATEWAY_DOMAIN: yup
      .string()
      .url()
      .required(),
    VITE_APP_PUBLIC_SITE_DOMAIN: yup
      .string()
      .url()
      .required(),
    VITE_APP_SEARCH_ADS_INSIGHTS_DOMAIN: yup
      .string()
      .url()
      .required(),
    VITE_APP_STRIPE_PUBLISHABLE_KEY: yup
      .string()
      .required(),
    VITE_APP_GOOGLE_RECAPTCHA_KEY: yup
      .string()
      .required(),
    VITE_APP_SENTRY_DSN: yup
      .string()
      .url()
      .required(),
    VITE_APP_MIX_PANEL_TOKEN: yup
      .string()
      .required(),
    VITE_APP_AD_INTEL_DOMAIN: yup
      .string()
      .url()
      .required(),
    VITE_APP_MA_CDN_BASE_URL: yup
      .string()
      .url()
      .required(),
    VITE_APP_AG_GRID_TABLE_LICENSE_KEY: yup
      .string()
      .required(),
    VITE_APP_HEROKU_ENV: yup
      .string()
      .oneOf(['production', 'staging', 'development'])
      .required(),
    VITE_SEGMENT_WRITE_KEY: yup
      .string()
      .required(),
    VITE_HUBSPOT_PORTAL_ID: yup
      .string()
      .matches(/^\d+$/)
      .required(),
    VITE_WOOTRIC_ACCOUNT_TOKEN: yup
      .string()
      .required(),
    VITE_APP_SENTRY_RELEASE: yup
      .string()
      .when(['VITE_APP_HEROKU_ENV'], {
        is: (herokuEnv: string) => herokuEnv === 'production',
        then: schema => schema.required(),
        otherwise: schema => schema.notRequired(),
      }),
  })
  .required()
